import React from 'react'
import { NavLink } from "react-router-dom";
import { Menu, Popup } from 'semantic-ui-react'

export default class PdfItem extends  React.Component {
  render() {
    const { invoice } = this.props
    var concept = invoice.concept
    if (concept) {
        return <Menu.Item icon='pencil' href={Routes.invoice_path({id: invoice.id, _options: true})} as='a'/>

    } else {
      return <Menu.Item icon='download' href={Routes.invoice_path({id: invoice.id, format: 'pdf', download: true, _options: true})} as='a'/>
    }
  }
}
